<script setup>
const userStore = useUserStore();

const openSearch = ref(false);

// Sidebars ref, SHOW | HIDE
const openPrimary = ref(false);
const openSecondary = ref(false);

// Navbar routes
const navigation = [
  {
    id: 'fgg22',
    name: 'marketplace',
    link: 'https://nft.ceek.com/',
    style: 'nav-link',
  },
  {
    id: '4c0b',
    name: 'channels',
    link: '/channel',
    style: 'nav-link',
  },
  {
    id: '93fd',
    name: 'stars',
    link: '/stars',
    style: 'nav-link',
  },
];

const triggerUpdate = () => {
  openPrimary.value = true;
  usePriceStore().FETCH_CEEK_PRICE();
  userStore.UPDATE_USER_BALANCE();
  userStore.REFRESH_SUBSCRIPTION_DATA();
};

provide('searchOpen', openSearch);
</script>

<template>
  <div class="sticky top-0 z-50">
    <header class="px-7 py-4 2xl:px-20">
      <div class="flex justify-between">
        <nav class="flex items-center gap-x-4 lg:gap-x-6">
          <NuxtLink aria-label="Home" to="/">
            <MoleculeNuxtIcon
              name="logo"
              class="block w-8 fill-white text-white transition-all hover:drop-shadow-[0_0px_10px_rgba(255,255,255,0.95)] sm:w-9 lg:w-12"
            />
          </NuxtLink>

          <ul
            class="order-1 hidden items-center gap-x-4 text-xs uppercase sm:flex lg:ml-6 lg:gap-x-6 lg:text-lg xl:text-2xl"
          >
            <li
              v-for="nav in navigation"
              :key="nav.id"
              :class="{ 'order-last': nav.name == 'live' }"
            >
              <NuxtLink
                no-prefetch
                class="flex items-center gap-2 transition-all"
                :class="nav.style"
                :to="nav.link"
              >
                {{ nav.name }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                no-prefetch
                class="flex items-center gap-1 rounded-lg bg-[#F52401] px-4 py-1.5 text-white transition-all hover:shadow-[0px_0px_25px_0px_#f52401d9] lg:gap-2 lg:px-5"
                to="/live"
              >
                <MoleculeNuxtIcon class="size-5 fill-white" name="live" />
                Live
              </NuxtLink>
            </li>
          </ul>

          <NuxtLink to="/discover" class="order-2">
            <MoleculeNuxtIcon class="size-6 fill-white lg:size-10" name="explore" />
          </NuxtLink>

          <MoleculeNuxtIcon
            name="search"
            class="order-2 -m-1 size-8 shrink-0 cursor-pointer fill-white/50 p-1 text-white transition hover:scale-125 sm:order-3 lg:size-10"
            @click="openSearch = !openSearch"
          />
        </nav>

        <div class="flex items-center gap-x-4 sm:gap-x-6 xl:gap-x-10">
          <MoleculePopover max-width="max-w-60" top="top-16" placement="center">
            <template #popover-button>
              <MoleculeNuxtIcon class="flex size-6 fill-white lg:size-9" name="events" />
            </template>
            <template #popover-content>
              <div class="p-4 text-xl font-semibold dark:text-white">
                <MoleculeActionGoLive
                  class="group flex w-full items-center gap-2 rounded-md p-2 transition-all hover:bg-primary-gradient hover:text-white active:scale-95"
                  ><span class="group-hover:text-white">Go Live Now</span></MoleculeActionGoLive
                >
                <NuxtLink
                  to="/event"
                  class="group flex items-center gap-2 rounded-md p-2 transition-all hover:bg-primary-gradient hover:text-white active:scale-95"
                >
                  <MoleculeNuxtIcon
                    class="size-7 fill-[url(#gradient-lightblue-purple)] group-hover:fill-white"
                    name="create-event"
                  />
                  <span class="group-hover:text-white">Host Event</span>
                  <span class="rounded-xl bg-[#E1D7FF] px-2 py-1 text-base text-[#4E0FFF]"
                    >βετα</span
                  ></NuxtLink
                >
                <NuxtLink
                  to="/my-faves/events"
                  class="group flex items-center gap-2 rounded-md p-2 transition-all hover:bg-primary-gradient hover:text-white focus:bg-primary-gradient active:scale-95"
                >
                  <MoleculeNuxtIcon
                    class="size-7 fill-[url(#gradient-lightblue-purple)] group-hover:fill-white"
                    name="sidebar/events-calendar"
                  />
                  <span class="group-hover:text-white">My Events</span>
                </NuxtLink>
              </div>
            </template>
          </MoleculePopover>
          <button
            type="button"
            aria-label="Open secondary sidebar"
            class="text-white"
            @click="openSecondary = true"
          >
            <MoleculeNuxtIcon class="size-6 fill-white lg:size-9" name="dots6" />
          </button>

          <ClientOnly>
            <template #default>
              <button
                v-if="userStore.IS_AUTHORIZED"
                type="button"
                aria-label="Open primary sidebar"
                @click="triggerUpdate"
              >
                <AtomAvatarPlaceholder />
              </button>

              <LazyAtomButtonSignInSignUp v-else />
            </template>
            <template #fallback>
              <AtomAvatarPlaceholder />
            </template>
          </ClientOnly>
        </div>
      </div>
      <Teleport to="body">
        <LazySICTheSearch v-if="openSearch" />
      </Teleport>
    </header>
    <lazy-molecule-layout-secondary-sidebar v-model="openSecondary" />
    <lazy-molecule-layout-primary-sidebar v-model="openPrimary" />
  </div>
</template>

<style scoped lang="scss">
// Header section
.nav-link {
  text-shadow: 0px 0px 10px #619bfe;
  color: #fff;

  &:hover {
    text-shadow: 0px 0px 10px #4239fe;
    color: #4239fe;
  }
}
// Header Section

header {
  background: linear-gradient(90deg, #080527 0%, #00479a 100%);
}
</style>
